/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_171_TitleInputs */

const en_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choco Chip Cupcake`)
};

const ar_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كب كيك رقائق الشوكولاتة`)
};

const de_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schokosplitter-Cupcake`)
};

const es_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake con chispas de chocolate`)
};

const fr_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake aux pépites de chocolat`)
};

const it_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake con gocce di cioccolato`)
};

const ja_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チョコチップカップケーキ`)
};

const ko_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초코칩 컵케이크`)
};

const pt_br_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake com Gotas de Chocolate`)
};

const ru_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Капкейк с шоколадной крошкой`)
};

const th_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัพเค้กช็อกโกแลตชิป`)
};

const tr_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Damla Çikolatalı Cupcake`)
};

const zh_cn_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可可碎纸杯蛋糕`)
};

const zh_tw_tree_type_171_title = /** @type {(inputs: Tree_Type_171_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可可碎片杯子蛋糕`)
};

/**
* | output |
* | --- |
* | "Choco Chip Cupcake" |
*
* @param {Tree_Type_171_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_171_title = /** @type {((inputs?: Tree_Type_171_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_171_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_171_title(inputs)
	if (locale === "ar") return ar_tree_type_171_title(inputs)
	if (locale === "de") return de_tree_type_171_title(inputs)
	if (locale === "es") return es_tree_type_171_title(inputs)
	if (locale === "fr") return fr_tree_type_171_title(inputs)
	if (locale === "it") return it_tree_type_171_title(inputs)
	if (locale === "ja") return ja_tree_type_171_title(inputs)
	if (locale === "ko") return ko_tree_type_171_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_171_title(inputs)
	if (locale === "ru") return ru_tree_type_171_title(inputs)
	if (locale === "th") return th_tree_type_171_title(inputs)
	if (locale === "tr") return tr_tree_type_171_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_171_title(inputs)
	return zh_tw_tree_type_171_title(inputs)
});